import { View } from 'react-native';

import { ActionSheet, Button, IconMail, Text, YStack, createMqStyles, tokens } from '@fhs/ui';

export const EmailInUseActionSheet = ({
  isVisible,
  email,
  onSignIn,
  onUseDifferentEmail,
}: {
  isVisible: boolean;
  email: string;
  onSignIn: () => void;
  onUseDifferentEmail: () => void;
}) => {
  const styles = useMqStyles();
  return (
    <ActionSheet
      isVisible={isVisible}
      onClose={() => {}}
      noPanGestureDetection
      grabber={false}
      drawerProps={{ style: styles.drawer }}
    >
      <YStack style={styles.container}>
        <View style={styles.iconMail}>
          <IconMail size={40} />
        </View>
        <View style={styles.content}>
          <Text.Heading type="two" style={{ textAlign: 'center' }}>
            This Email Is Already In Use!
          </Text.Heading>
          <View style={styles.emailContainer}>
            <Text.Paragraph size="sm">{email}</Text.Paragraph>
          </View>
          <View style={styles.buttonContainer}>
            <Button size="md" style={{ flex: 1 }} onPress={onSignIn}>
              <Button.Text>Sign In</Button.Text>
            </Button>
            <Button
              size="md"
              type="outline-subtle"
              style={{ flex: 1 }}
              onPress={onUseDifferentEmail}
            >
              <Button.Text>Use Different Email</Button.Text>
            </Button>
          </View>
        </View>
      </YStack>
    </ActionSheet>
  );
};

const useMqStyles = createMqStyles({
  drawer: {
    $base: {
      width: '100%',
    },
    $gteDesktop: {
      width: 520,
    },
  },
  content: {
    $base: {
      gap: 16,
      width: '100%',
    },
  },
  container: {
    $base: {
      width: '100%',
      gap: 8,
      padding: 16,
      alignItems: 'center',
    },
    $gteDesktop: {
      padding: 28,
    },
  },
  iconMail: {
    $base: {
      height: 64,
      width: 64,
      backgroundColor: tokens.colors.$blackOpacity04,
      borderRadius: 200,
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  emailContainer: {
    $base: {
      alignItems: 'center',
      borderWidth: 1,
      borderColor: tokens.colors.$blackOpacity10,
      borderRadius: 8,
      paddingVertical: 12,
      paddingHorizontal: 16,
    },
    $gteDesktop: {
      paddingVertical: 24,
      paddingHorizontal: 24,
    },
  },
  buttonContainer: {
    $base: {
      flexDirection: 'column',
      gap: 8,
    },
    $gteDesktop: {
      flexDirection: 'row-reverse',
    },
  },
});

export default EmailInUseActionSheet;
